import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import "leaflet/dist/leaflet.css";
import { useState } from "react";
import { MapContainer, Marker, Polygon, TileLayer, Tooltip, useMapEvents } from "react-leaflet";
import { Link, useNavigate } from "react-router-dom";
import { loadJSON, round } from "./util";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

let daily_wind = await loadJSON(
  "https://limmattalerwetter.ch/forecast/DAILY_WIND.json"
);

let fcst_lakes = await loadJSON(
  "https://limmattalerwetter.ch/forecast/fcst_lakes.geojson"
);

// Extract coordinates. Geojson standard is (lon, lat) but we need it in (lat, lon) and coordinates are conventiently stored in subarrays...
const lakes_polys = fcst_lakes.features.map((lake) => lake.geometry.coordinates.map((sub) => sub.map((coords) => coords.reverse())));
const lakes_names = fcst_lakes.features.map((lake) => lake.properties.Name);
//console.log(lakes_polys);

const days = Object.keys(daily_wind["TEL-vmax"]);
days.sort();
const weekdays = days.map(function (x) {
  let date = new Date(Number(x));
  return date.toLocaleDateString("de-DE", {
    weekday: "long",
    day: "2-digit",
    month: "2-digit",
  });
});

let DefaultIcon = L.icon({
  iconUrl: icon,
  iconAnchor: [12, 41],
  iconSize: [0, 0],
});

L.Marker.prototype.options.icon = DefaultIcon;

function OverlayLayer() {
  const [selday, setday] = useState(0);
  const [zoomLevel, setZoomLevel] = useState(9); // initial zoom level provided for MapContainer
  const [metric, setmetric] = useState("mean");
  const [threshold, setthres] = useState(14);
  const mapEvents = useMapEvents({
      zoomend: () => {
          setZoomLevel(mapEvents.getZoom());
      },
  });

  const handleMetricChange = (event) => {
    setmetric(event.target.value);
  };

  //console.log(zoomLevel);

  var markers = [
    {
      name: "Alpnachersee",
      coords: [46.97, 8.31],
      uri: "/alpnachersee",
      speed: daily_wind[`TEL-${metric}`][days[selday]],
      dir: daily_wind[`TEL-${metric}-dir`][days[selday]],
      zoom: 8
    },
    {
      name: "Urnersee",
      coords: [46.9, 8.6],
      uri: "/urnersee",
      speed: daily_wind[`GRO-${metric}`][days[selday]],
      dir: daily_wind[`GRO-${metric}-dir`][days[selday]],
      zoom: 5
    },
    {
      name: "Greifensee",
      coords: [47.39, 8.671163],
      uri: "/greifensee",
      speed: daily_wind[`GRE-${metric}`][days[selday]],
      dir: daily_wind[`GRE-${metric}-dir`][days[selday]],
      zoom: 8
    },
    {
      name: "Zürichsee",
      coords: [47.270209, 8.627748],
      uri: "/zuerichsee",
      speed: daily_wind[`MEI-${metric}`][days[selday]],
      dir: daily_wind[`MEI-${metric}-dir`][days[selday]],
      zoom: 7
    },
    {
      name: "Murtensee",
      coords: [46.935868, 7.118438],
      uri: "/murtensee",
      speed: daily_wind[`MUR-${metric}`][days[selday]],
      dir: daily_wind[`MUR-${metric}-dir`][days[selday]],
      zoom: 8
    },
    {
      name: "Neuenburgersee",
      coords: [46.809746, 6.734867],
      uri: "/neuenburgersee",
      speed: daily_wind[`SBL-${metric}`][days[selday]],
      dir: daily_wind[`SBL-${metric}-dir`][days[selday]],
      zoom: 7
    },
    {
      name: "Gardasee",
      coords: [45.865093, 10.865807],
      uri: "/gardasee",
      speed: daily_wind[`TOR-${metric}`][days[selday]],
      dir: daily_wind[`TOR-${metric}-dir`][days[selday]],
      zoom: 5
    },
    {
      name: "Sihlsee",
      coords: [47.1, 8.791283],
      uri: "/sihlsee",
      speed: daily_wind[`SIL-${metric}`][days[selday]],
      dir: daily_wind[`SIL-${metric}-dir`][days[selday]],
      zoom: 9
    },
    {
      name: "Silvaplanersee",
      coords: [46.433357, 9.793968],
      uri: "/silvaplanersee",
      speed: daily_wind[`SVP-${metric}`][days[selday]],
      dir: daily_wind[`SVP-${metric}-dir`][days[selday]],
      zoom: 7
    },
    {
      name: "Walensee",
      coords: [47.121841, 9.174886],
      uri: "/walensee",
      speed: daily_wind[`MUL-${metric}`][days[selday]],
      dir: daily_wind[`MUL-${metric}-dir`][days[selday]],
      zoom: 8
    },
    {
      name: "Untersee",
      coords: [47.669938, 8.979599],
      uri: "/untersee",
      speed: daily_wind[`STK-${metric}`][days[selday]],
      dir: daily_wind[`STK-${metric}-dir`][days[selday]],
      zoom: 5
    },
    {
      name: "Zugersee",
      coords: [47.173257, 8.492687],
      uri: "/zugersee",
      speed: daily_wind[`ZUG-${metric}`][days[selday]],
      dir: daily_wind[`ZUG-${metric}-dir`][days[selday]],
      zoom: 9
    },
    {
      name: "Comersee",
      coords: [46.011202, 9.262386],
      uri: "/comersee",
      speed: daily_wind[`COL-${metric}`][days[selday]],
      dir: daily_wind[`COL-${metric}-dir`][days[selday]],
      zoom: 7
    },
    {
      name: "Lago Maggiore",
      coords: [46.081187, 8.716739],
      uri: "/lagomaggiore",
      speed: daily_wind[`CAN-${metric}`][days[selday]],
      dir: daily_wind[`CAN-${metric}-dir`][days[selday]],
      zoom: 8
    },
    {
      name: "Bielersee",
      coords: [47.113628, 7.206840],
      uri: "/bielersee",
      speed: daily_wind[`BIL-${metric}`][days[selday]],
      dir: daily_wind[`BIL-${metric}-dir`][days[selday]],
      zoom: 7
    },
    {
      name: "Ägerisee",
      coords: [47.129541, 8.606517],
      uri: "/aegerisee",
      speed: daily_wind[`AEG-${metric}`][days[selday]],
      dir: daily_wind[`AEG-${metric}-dir`][days[selday]],
      zoom: 10
    },
    {
      name: "Thunersee",
      coords: [46.677728, 7.805410],
      uri: "/thunersee",
      speed: daily_wind[`TUN-${metric}`][days[selday]],
      dir: daily_wind[`TUN-${metric}-dir`][days[selday]],
      zoom: 8
    },
    {
      name: "Sempachersee",
      coords: [47.140121, 8.145240],
      uri: "/sempachersee",
      speed: daily_wind[`SEM-${metric}`][days[selday]],
      dir: daily_wind[`SEM-${metric}-dir`][days[selday]],
      zoom: 8
    },
    {
      name: "Obersee",
      coords: [47.213255, 8.832077],
      uri: "/obersee",
      speed: daily_wind[`OBE-${metric}`][days[selday]],
      dir: daily_wind[`OBE-${metric}-dir`][days[selday]],
      zoom: 9
    },
    {
      name: "Hallwilersee",
      coords: [47.282634, 8.221601],
      uri: "/hallwilersee",
      speed: daily_wind[`HAL-${metric}`][days[selday]],
      dir: daily_wind[`HAL-${metric}-dir`][days[selday]],
      zoom: 10
    },
    {
      name: "Lac du Rosel",
      coords: [46.12549, 7.060323],
      uri: "/lacdurosel",
      speed: daily_wind[`ROS-${metric}`][days[selday]],
      dir: daily_wind[`ROS-${metric}-dir`][days[selday]],
      zoom: 8
    },
  ];

  return (
    <div className="overlay">
      <div className="metric_selector">
        <Select
          value={metric}
          onChange={handleMetricChange}
          >
          <MenuItem value={"mean"}>3h Mean</MenuItem>
          <MenuItem value={"vmax"}>Daily Max</MenuItem>
        </Select>
      </div>
      <div className="day_selector">
        {Array.from(Array(5), (e, i) => {
          if (selday === i) {
            var classname = "day currentday"
          } else {
            var classname = "day"
          }
          return (
            <button className={classname} onClick={() => setday(i)}>
              {weekdays[i]}
            </button>
          );
        })}
      </div>
      {Array.from(Array(markers.length), (e, i) => {
        return <Tooltips data={markers[i]} zoomLevel={zoomLevel} threshold={threshold} />;
      })}
    </div>
  );
}

function Tooltips({ data, zoomLevel, threshold }) {

  // Find polygon index
  let lake_ind = lakes_names.findIndex((x) => x === data.name);
  //console.log("lake" + data.name + " ID " + lake_ind);

  // Add navigation ability
  let navigate = useNavigate();

  const speed = 1.9438444924406 * data.speed;
  if (speed > threshold) {
    var bg_color = "green";
  } else {
    var bg_color = "#41a1ddff";
  }

  function click() {
    navigate(data.uri);
  }

  if (data.zoom > zoomLevel) {
    return (
    <Marker position={data.coords} offset={[0, 0]}>
      <Link to={data.uri}>
      <Polygon pathOptions={{color: bg_color}} positions={lakes_polys[lake_ind]} eventHandlers={onclick={click}} />
      </Link>
    </Marker>
  );
  }
  else {
    return (
    <Marker position={data.coords} offset={[0, 0]}>
      <Tooltip
        direction="center"
        offset={[0, 10]}
        opacity={1}
        permanent
        interactive={true}
      >
        <Link to={data.uri}>
          <div className="spot_wrapper">
            <div className="spot_name">{data.name}</div>
            <div className="spot_fc" style={{ backgroundColor: `${bg_color}` }}>
              {round(speed, 1)}kn{" "}
              <ArrowDownwardIcon
                style={{ transform: `rotate(${data.dir}deg)` }}
                className="spot_arrow"
              />
            </div>
          </div>
        </Link>
      </Tooltip>
      <Polygon pathOptions={{color: bg_color}} positions={lakes_polys[lake_ind]} eventHandlers={onclick={click}} />
    </Marker>
  );
  }
}

export default function IndexMap() {
  const center = [47.1, 8.5];
  const now = Date.now();
  // const today = now.setHours(0,0,0,0);
  // console.log(now);

  return (
    <section className="map-component">
      <div className="map">
        <MapContainer center={center} zoom={9} scrollWheelZoom={true}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
            url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          />
          <OverlayLayer />
        </MapContainer>
      </div>
    </section>
  );
}
